import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=2da9b9e6"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RecipesCategories: require('/vercel/path0/components/recipesCategories.vue').default,RecipeSummary: require('/vercel/path0/components/recipeSummary.vue').default,Intermission: require('/vercel/path0/components/intermission.vue').default,LoadMore: require('/vercel/path0/components/ui/loadMore.vue').default})
